import TripTypeInput, {
  TripTypeInputOnChangeArgs,
  TripTypeInputProps,
  tripTypes,
} from 'lib/components/Form/TripTypeInput/TripTypeInput'
import { useCallback, useEffect, useMemo } from 'react'
import { Control } from 'react-hook-form'
import {
  BookingWidgetCollapsibleContentArgs,
  BookingWidgetCollapsibleSettings,
} from '../partials/BookingWidgetCollapsible'
import { useBookingWidgetStore } from '../providers/BookingWidgetContext'

export type TripTypeInputContentProps = BookingWidgetCollapsibleContentArgs

export interface TripTypeContentProps {
  control: Control
  sticky?: boolean
}

export const tripTypeInputCollapsible: BookingWidgetCollapsibleSettings = {
  label: 'Trip Type',
  id: 'tripType',
  defaultEnabled: true,
}

export const TripTypeContent = ({ control, sticky }: TripTypeContentProps) => {
  const { tripType, isCruise, setTripType, setIsCruise, brand } =
    useBookingWidgetStore()

  const onTripTypeChange = useCallback(
    async ({ type, isCruise: cruise }: TripTypeInputOnChangeArgs) => {
      if (tripType !== type) {
        setTripType?.(type)
      }
      if (isCruise !== cruise) {
        setIsCruise?.(cruise)
      }
    },
    [setTripType, setIsCruise, tripType, isCruise],
  )

  return (
    brand && (
      <TripTypeInput
        brand={brand}
        type={tripType}
        isCruise={isCruise}
        control={control}
        onChange={onTripTypeChange}
        className="lg:justify-start lg:gap-x-12 w-full"
        cruiseLabel="This trip includes a cruise"
        childrenClassNames={{
          CheckboxInput: sticky && 'lg:mx-auto',
        }}
        // noCruiseOption={/camps/i.test(brand || '') || partner ? true : false}
        noCruiseOption={true}
      />
    )
  )
}

export default function TripTypeInputContent({
  control,
  formatSummary,
  sticky,
  NextButton,
}: TripTypeInputContentProps) {
  const { tripType } = useBookingWidgetStore()

  const tripTypeLabel: string = useMemo(
    () => tripTypes[tripType as Required<TripTypeInputProps>['type']],
    [tripType],
  )

  useEffect(() => {
    formatSummary?.(tripTypeLabel || tripTypeInputCollapsible.label || '')
  }, [tripTypeLabel, formatSummary])

  return (
    <div className="w-full flex">
      <TripTypeContent control={control} sticky={sticky} />
      {NextButton}
    </div>
  )
}
